import moment from "moment";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import {
    actualizarAlertaLoading,
    cerrarAlerta,
    mostraAlertaError,
    mostraAlertaOk,
    mostrarAlertaLoading,
} from "../../../../componentes/alerts/sweetAlert";
import { cargarPorRangos, textoProgreso } from "../../../../componentes/datos/CargaPorRangos";
import { invalidarPrefijo } from "../../../../componentes/datos/cacheLocal";
import { AxiosPrivado } from "../../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../../componentes/axios/ErroresPeticion";
import Card from "../../../../componentes/contenedores/Card";
import { IdentificarEstacion } from "../../../../componentes/estacion/Estacion";
import MetodosPagoDinamicos from "../../../../componentes/metodos/MetodosPagos";
import ModalWizardBootstrap from "../../../../componentes/modal/ModalWizardBootstrap";
import Page from "../../../../componentes/plantilla/Page";
import Tablas from "../../../../componentes/tablas/TablasGenerico";
import {
    CajaVerificar,
    VentaPagaCredito,
    VentaFiltro,
    VentaListarId
} from "../../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../../contexto/usuario/UsuarioContext";
import { formatoMoneda } from "../../../../configuracion/validaciones";
import ReporteCredito from "./ReporteCredito";
import { pdf } from '@react-pdf/renderer';
import Swal from "sweetalert2";
import ModalBootstrap from "../../../../componentes/modal/ModalBootstrap";


const HomeCredito = () => {
    const { usuario } = useContextUsuario();
    const { listaEmpleados, listaClientes } = useContextEmpleado();
    const refEdicion = useRef(null);
    // Controlador de la carga por lotes en curso, para poder cancelarla.
    const refCarga = useRef(null);
    const [ventaSeleccionada, setVentaSeleccionada] = useState(null);
    const [modalOpen2, setModalOpen2] = useState(false);
    const [efectivo, setEfectivo] = useState(0);
    const [pos, setPos] = useState(0);
    const [transferencias, setTransferencias] = useState(0);
    const [totalRecibido, setTotalRecibido] = useState(0);
    const [montosPos, setMontosPos] = useState({});
    const [montosTransferencia, setMontosTransferencia] = useState({});
    const [referenciasPos, setReferenciasPos] = useState({});
    const [referenciasTransferencia, setReferenciasTransferencia] = useState({});
    const [erroresReferenciaPos, setErroresReferenciaPos] = useState({});
    const [erroresReferenciaTransferencia, setErroresReferenciaTransferencia] = useState({});
    const [cajaId, setCajaId] = useState(null);
    const [cajaAbierta, setCajaAbierta] = useState(false);
    const [panelAbierto, setPanelAbierto] = useState(false);
    const [estadoFiltroTemp, setEstadoFiltroTemp] = useState("TODOS");
    // Una pantalla de creditos debe abrir mostrando la deuda viva, no solo
    // lo vendido esta semana: un credito pendiente de hace meses sigue
    // siendo deuda hoy. El rango largo es viable porque la carga va en
    // ventanas mensuales secuenciales (ver CargaPorRangos.js).
    const RANGO_INICIAL_MESES = 3;

    const [fechaInicio, setFechaInicio] = useState(
        moment().subtract(RANGO_INICIAL_MESES, "months").format("YYYY-MM-DD")
    );
    const [fechaFin, setFechaFin] = useState(moment().format("YYYY-MM-DD"));
   
    const [creditosFiltrados, setCreditosFiltrados] = useState([]);

    const [empleadoFiltroTemp, setEmpleadoFiltroTemp] = useState("TODOS");

    const [selectedEvent, setSelectedEvent] = useState({});
    const [modalClienteOpen, setModalClienteOpen] = useState(false);
    const [clienteSearchTerm, setClienteSearchTerm] = useState("");
    const clientes = listaClientes || [];

    const verificarYCargarCaja = async () => {
        try {
            const estacionDatos = await IdentificarEstacion();
            const response = await AxiosPrivado.post(CajaVerificar, { estacionDatos });
            if (response.data.estado === "CE") {
                mostraAlertaError("La caja ya está cerrada. No se puede registrar ventas.");
                return;
            }
            const caja = response.data;
            setCajaId(caja.id);
            // El backend usa los codigos "AB" (abierta) y "CE" (cerrada); nunca
            // la palabra "Abierta", asi que la comparacion anterior daba siempre
            // false. Se usa el mismo criterio que HomeCierre: lo que no es CE
            // esta operable.
            setCajaAbierta(caja.estado !== "CE");
            return true;
        } catch (error) {
            ErroresPeticion(error);
            return false;
        }
    };

    const [datosPago, setDatosPago] = useState({
        recibido: totalRecibido,
        tipoVenta: "Contado",
        documento: "FA",
        efectivo: [],
        transferencia: [],
        tarjeta: [],
        montoCredito: 0,
        fecha: "",
        fechaVencimiento: "",
        saldo: 0,
    });

    const Total = ventaSeleccionada && ventaSeleccionada.totalVenta
        ? parseFloat(ventaSeleccionada.totalVenta)
        : 0;

    const actualizarListaPagos = useCallback(() => {
        let tipoPagoValido = "Efectivo";

        if (totalRecibido > 0) {
            if (parseFloat(efectivo) > 0 && transferencias === 0 && pos === 0) {
                tipoPagoValido = "Efectivo";
            } else if (transferencias > 0 && pos === 0) {
                tipoPagoValido = "Transferencia";
            } else if (pos > 0 && transferencias === 0) {
                tipoPagoValido = "Tarjeta";
            } else {
                tipoPagoValido = "Mixto";
            }
        }

        let tipoVenta = "Contado";
        if (datosPago.documento === "CR") {
            tipoVenta = "Crédito";
        }

        let nPago = {
            pago: Total,
            recibido: totalRecibido,
            tipo: tipoPagoValido,
            documento: datosPago.documento,
            tipoVenta: tipoVenta,
            fecha: moment().format("YYYY-MM-DD"),
            efectivo:
                parseFloat(efectivo) > 0 ? [{ monto: parseFloat(efectivo) }] : [],
        };

        const listaTransferencias = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));

        if (listaTransferencias.length > 0) {
            nPago = { ...nPago, transferencia: listaTransferencias };
        }

        const listaPos = Object.keys(montosPos)
            .filter(posId => parseFloat(montosPos[posId] || 0) > 0)
            .map(posId => ({
                monto: parseFloat(montosPos[posId]),
                referencia: referenciasPos[posId] || "",
                posId: parseInt(posId, 10),
            }));

        if (listaPos.length > 0) {
            nPago = { ...nPago, tarjeta: listaPos };
        }

        setDatosPago(nPago);
    }, [datosPago.documento, efectivo, montosPos, montosTransferencia, pos, referenciasPos, referenciasTransferencia, Total, totalRecibido, transferencias]);

useEffect(() => {
        obtenerCreditosFiltrados(estadoFiltroTemp, empleadoFiltroTemp, selectedEvent?.clienteId, fechaInicio, fechaFin);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const nuevoTotal = parseFloat(pos) + parseFloat(transferencias) + parseFloat(efectivo);
        if (nuevoTotal !== totalRecibido) setTotalRecibido(nuevoTotal);
        actualizarListaPagos();
    }, [pos, transferencias, efectivo, actualizarListaPagos, totalRecibido]);

    // La caja se verifica al entrar a la pantalla, no en cada cambio de monto.
    useEffect(() => {
        verificarYCargarCaja();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Al salir de la pantalla se corta la carga en vuelo: no tiene sentido
    // que el servidor siga trabajando para una vista que ya no existe.
    useEffect(() => {
        return () => {
            if (refCarga.current) {
                refCarga.current.abort();
            }
        };
    }, []);

    const limpiarDatosPago = () => {
        const nuevoInicio = moment()
            .subtract(RANGO_INICIAL_MESES, "months")
            .format("YYYY-MM-DD");
        setFechaInicio(nuevoInicio);
        setEfectivo(0);
        setTotalRecibido(0);
        setPos(0);
        setTransferencias(0);
        setMontosPos({});
        setReferenciasPos({});
        setErroresReferenciaPos({});
        setMontosTransferencia({});
        setReferenciasTransferencia({});
        setErroresReferenciaTransferencia({});
        obtenerCreditosFiltrados(estadoFiltroTemp, empleadoFiltroTemp, selectedEvent?.clienteId, nuevoInicio, fechaFin);
    };

    /**
     * Fusiona el detalle sobre el objeto que ya venia de la lista.
     * Es deliberadamente conservador: si el endpoint de detalle no trae una
     * clave, o la trae vacia, se conserva la de la lista. Asi el panel nunca
     * muestra menos de lo que mostraba antes de este cambio.
     */
    const fusionarDetalle = (anterior, detalle) => {
        const resultado = { ...anterior };
        Object.keys(detalle).forEach((clave) => {
            const valor = detalle[clave];
            if (valor !== undefined && valor !== null) {
                resultado[clave] = valor;
            }
        });
        return resultado;
    };

    /**
     * Pide la venta por id al seleccionarla, en lugar de depender de que la
     * lista haya traido todas las relaciones. Es el paso que permite que el
     * listado deje de cargar ventadetallepedidos, pagoVenta y companhia para
     * cada fila. Si la peticion falla se queda lo de la lista, sin molestar
     * al usuario con un error.
     */
    const refrescarDetalleVenta = async (venta) => {
        if (!venta?.id) return;
        try {
            const { data } = await AxiosPrivado.get(VentaListarId + venta.id, {
                timeout: 20000,
            });
            const detalle = Array.isArray(data) ? data[0] : data;
            if (!detalle || !detalle.id) return;

            // Puede haber cambiado la seleccion mientras llegaba la respuesta.
            setVentaSeleccionada((previa) =>
                previa?.id === detalle.id ? fusionarDetalle(previa, detalle) : previa
            );
        } catch (error) {
            console.error("No se pudo refrescar el detalle de la venta:", error);
        }
    };

    const handleSeleccionarVenta = (venta) => {
        // Se pinta de inmediato con lo que ya hay para que el panel no quede
        // vacio, y el detalle se refresca cuando llega.
        setVentaSeleccionada(venta);
        setTimeout(() => {
            if (refEdicion.current) {
                refEdicion.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }
        }, 100);
        refrescarDetalleVenta(venta);
    };

    const totalVenta = ventaSeleccionada ? parseFloat(ventaSeleccionada.totalVenta || 0) : 0;

    const totalPagado = ventaSeleccionada?.pagoVenta?.length
        ? ventaSeleccionada.pagoVenta.filter(p => p.pago.estado !== "Anulada").reduce(
            (sum, pagoVentaItem) => sum + parseFloat(pagoVentaItem.pago.recibido || 0),
            0
        )
        : 0;

    const saldoPendiente = totalVenta - totalPagado;


    const validarAbonoCredito = ({
        efectivo,
        tarjeta,
        transferencia,
        saldoPendiente,
    }) => {
        const totalRecibido = efectivo + tarjeta + transferencia;
        const totalElectronico = tarjeta + transferencia;

        // Debe existir un abono
        if (totalRecibido <= 0) {
            return "Debe ingresar un monto mayor a cero.";
        }

        // Tarjeta y transferencia no generan cambio
        if (totalElectronico > saldoPendiente) {
            return `El monto pagado con tarjeta o transferencia no puede exceder el saldo pendiente de L. ${saldoPendiente.toFixed(2)}.`;
        }

        // Si hay cambio, debe provenir únicamente del efectivo
        if (totalRecibido > saldoPendiente) {
            const cambio = totalRecibido - saldoPendiente;

            if (efectivo < cambio) {
                return "El cambio solo puede generarse por un excedente en efectivo.";
            }
        }

        return null;
    };


    const validarReferencias = () => {
        let hayError = false;

        let nuevosErroresPos = {};
        let nuevosErroresTransferencia = {};

        Object.keys(montosPos).forEach(posId => {
            if (parseFloat(montosPos[posId] || 0) > 0) {
                const ref = referenciasPos[posId] || "";
                if (!/^\d{6,15}$/.test(ref)) {
                    nuevosErroresPos[posId] = "La referencia debe tener entre 6 y 15 dígitos numéricos.";
                    hayError = true;
                }
            }
        });

        Object.keys(montosTransferencia).forEach(cuentaId => {
            if (parseFloat(montosTransferencia[cuentaId] || 0) > 0) {
                const ref = referenciasTransferencia[cuentaId] || "";
                if (!/^\d{8,15}$/.test(ref)) {
                    nuevosErroresTransferencia[cuentaId] = "La referencia debe tener entre 8 y 15 dígitos numéricos.";
                    hayError = true;
                }
            }
        });

        setErroresReferenciaPos(nuevosErroresPos);
        setErroresReferenciaTransferencia(nuevosErroresTransferencia);

        if (hayError) {
            mostraAlertaError("Hay referencias inválidas. Verifica los campos marcados.", "Error de validación");
        }

        return !hayError;
    };

    const generarListaTransferencias = () => {
        const lista = Object.keys(montosTransferencia)
            .filter(cuentaId => parseFloat(montosTransferencia[cuentaId] || 0) > 0)
            .map(cuentaId => ({
                monto: parseFloat(montosTransferencia[cuentaId]),
                referencia: referenciasTransferencia[cuentaId] || "",
                cuentaId: parseInt(cuentaId, 10),
            }));
        return lista;
    };

    const generarListaPos = () => {
        const lista = Object.keys(montosPos)
            .filter(posId => parseFloat(montosPos[posId] || 0) > 0)
            .map(posId => ({
                monto: parseFloat(montosPos[posId]),
                referencia: referenciasPos[posId] || "",
                posId: parseInt(posId, 10),
            }));
        return lista;
    };

    const confirmarPagoCredito = async () => {
        mostrarAlertaLoading("Registrando pago a crédito...");
        if (!validarReferencias()) {
            mostraAlertaError("Corrige las referencias inválidas antes de continuar.", "Error");
            return;
        }
        const esCredito = Boolean(
            ventaSeleccionada?.tieneCredito ||
            ventaSeleccionada?.creditoId ||
            (ventaSeleccionada?.creditos?.length || 0) > 0 ||
            ventaSeleccionada?.tipoVenta === "Credito"
        );
        const totalVenta = parseFloat(ventaSeleccionada?.totalVenta || 0);
        const ventaId = ventaSeleccionada?.id;
        const efectivoNum = (datosPago.efectivo || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const posNum = (datosPago.tarjeta || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const transferenciaNum = (datosPago.transferencia || []).reduce((acc, pago) => acc + parseFloat(pago.monto || 0), 0);
        const totalRecibidoNum = efectivoNum + posNum + transferenciaNum;

        const totalPagado =
            ventaSeleccionada?.pagoVenta
                ?.filter(pv => pv.pago?.estado !== "Anulada")
                .reduce(
                    (sum, pv) => sum + parseFloat(pv.pago?.pago || 0),
                    0
                ) || 0;

        const saldoActual = totalVenta - totalPagado;
        const abonoAplicado = Math.min(totalRecibidoNum, saldoActual);
        if (!esCredito) {
            mostraAlertaError("Esta venta no es a crédito.", "Error");
            return;
        }
        const mensajeError = validarAbonoCredito({
            efectivo: efectivoNum,
            tarjeta: posNum,
            transferencia: transferenciaNum,
            saldoPendiente: saldoActual
        });
        if (mensajeError) {
            mostraAlertaError(mensajeError, "Error");
            return;
        }
        if (!cajaId) {
            mostraAlertaError("Caja no autenticada");
            return;
        }
        // Para abonar, la caja TIENE que estar abierta. La guarda anterior
        // decia lo contrario: era el mensaje de HomeApertura, donde si aplica
        // (no se puede abrir una caja ya abierta), copiado a esta pantalla.
        if (!cajaAbierta) {
            mostraAlertaError("La caja no está abierta. No se puede registrar el abono.");
            return;
        }
        if (!ventaId) {
            mostraAlertaError("No se encontró información válida de la compra.", "Error");
            return;
        }
        const nuevoPago = {
            fecha: moment().toISOString(),
            pago: abonoAplicado,
            recibido: totalRecibidoNum,
            documento: "CR",
            estado: "Completada",
            ventaId,
            cajaId,
            efectivo: datosPago.efectivo || [],
            transferencia: generarListaTransferencias(),
            tarjeta: generarListaPos()
        };
        try {
            await AxiosPrivado.post(VentaPagaCredito, {
                pago: nuevoPago,
            });
            mostraAlertaOk("Pago registrado correctamente.", "Éxito");
            // El pago cambia el estado y el saldo de un credito que puede
            // pertenecer a un mes ya cacheado: hay que invalidarlo.
            await invalidarPrefijo("ventas");
            setVentaSeleccionada(null);
            setModalOpen2(false);
            limpiarDatosPago();
            setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
            }, 100);
        } catch (er) {
            const { response } = er;
            const msjError =
                response?.data?.msj ||
                response?.data?.error?.message ||
                "Ocurrió un error desconocido.";
            mostraAlertaError(msjError, "Error");
        }
    };

    const handleImprimirReporte = async (venta) => {
        Swal.fire({
            title: 'Generando PDF...',
            text: 'Por favor, espere un momento.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        if (venta) {
            try {
                let ventaCompleta = venta;
                // Si la venta viene del listado optimizado y le faltan relaciones completas
                // para el PDF, refrescar el detalle individual desde la API.
                if (!venta.pagoVenta || !venta.creditos || venta.creditos.length === 0) {
                    try {
                        const { data } = await AxiosPrivado.get(VentaListarId + venta.id, {
                            timeout: 10000,
                        });
                        const detalle = Array.isArray(data) ? data[0] : data;
                        if (detalle && detalle.id) {
                            ventaCompleta = fusionarDetalle(venta, detalle);
                        }
                    } catch (e) {
                        console.warn("No se pudo obtener detalle extendido para reporte:", e);
                    }
                }

                const blob = await pdf(<ReporteCredito venta={ventaCompleta} />).toBlob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `ReporteCredito_${venta.id}.pdf`;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
                Swal.close();
            } catch (error) {
                Swal.close();
                mostraAlertaError("Error al generar el PDF. Inténtelo de nuevo.");
            }
        } else {
            Swal.close();
            mostraAlertaError("No se encontraron detalles para generar el reporte.", "Error");
        }
    };

    const columnas = useMemo(
        () => [
            {
                title: "ID",
                data: null,
                render: (row) => {
                    const factura = row.numeroFacturaDoc || row.numeroFactura || row.facturas?.[0]?.numeroFactura;
                    const recibo = row.numeroReciboDoc || row.recibos?.[0]?.id;
                    const credito = row.creditoId || row.creditos?.[0]?.id;

                    return `
                        <div class="fw-semibold">#${row.id}</div>

                        ${factura ? `<span class="badge bg-primary">FA ${factura}</span>` : ""}
                        ${recibo ? `<span class="badge bg-info">RC ${recibo}</span>` : ""}
                        ${credito ? `<span class="badge bg-warning text-light">CR ${credito}</span>` : ""}
                    `;
                }
            },
            {
                title: 'Fechas',
                data: null,
                render: (row) => {
                    const fechaOperacion =
                        row.facturaFecha ||
                        row.reciboFecha ||
                        row.creditoFecha ||
                        row.facturas?.[0]?.fecha ||
                        row.recibos?.[0]?.fecha ||
                        row.creditos?.[0]?.fecha ||
                        row.createdAt ||
                        row.fecha;

                    const fechaVencimiento =
                        row.creditoVencimiento ||
                        row.creditos?.[0]?.fechaVencimiento;

                    const fechaHtml = fechaOperacion
                        ? `<div>${moment(fechaOperacion).format('DD/MM/YYYY')}</div>`
                        : '<div>—</div>';

                    const vencimientoHtml = fechaVencimiento
                        ? `<span class="badge bg-warning text-light">
                                Vence: ${moment(fechaVencimiento).format('DD/MM/YYYY')}
                            </span>`
                        : '';

                    return `${fechaHtml}${vencimientoHtml}`;
                },
            },
            {
                title: "Cliente",
                data: null,
                render: (row) => {
                    const cliente = row.Cliente;
                    const clienteNombre = row.clienteNombre || cliente?.nombreCompleto;
                    const empresas = cliente?.ClienteEmpresas?.length > 0
                        ? cliente.ClienteEmpresas
                            .map((empresa) => `<div>${empresa.nombre || ""}</div>`)
                            .join("")
                        : "";

                    const clienteNombreHtml = clienteNombre
                        ? `<div class="text-muted">${clienteNombre}</div>`
                        : "";

                    return empresas || clienteNombreHtml
                        ? `${empresas}${clienteNombreHtml}`
                        : "Sin cliente";
                },
            },
            {
                title: "Vendedor",
                data: null,
                render: (dataRow) => {
                    const vendedor = dataRow.empleadoNombre || dataRow.Empleado?.nombreCompleto || "Sin vendedor";
                    const cajaNombre = dataRow.cajaNombre || dataRow.caja?.nombre;
                    const cajaDispositivo = dataRow.cajaDispositivo || dataRow.caja?.estacione?.dispositivo;
                    return `
                        <div>
                            <div class="fw-bold text-dark">
                                ${vendedor}
                            </div>
                            ${cajaNombre ? `
                                <div class="small text-muted">
                                    Caja: ${cajaNombre}
                                </div>
                                <div class="small text-muted">
                                    Dispositivo: ${cajaDispositivo || "-"}
                                </div>
                            ` : ""}
                        </div>
                    `;
                },
            },
            {
                title: 'Mora',
                data: null,
                render: (rowData) => {
                    const diasMora = Number(rowData.creditoDiasMora ?? rowData.creditos?.[0]?.diasMora ?? 0);
                    let badgeClass = "bg-info text-white";

                    if (diasMora > 60) {
                        badgeClass = "bg-danger text-light";
                    } else if (diasMora >= 30) {
                        badgeClass = "bg-warning text-light";
                    }
                    return `<span class="badge ${badgeClass}">${diasMora} Días</span>`;
                },
            },
            {
                title: "Total",
                data: "totalVenta",
                render: (data) => {
                    const valorFormateado = formatoMoneda(data);
                    return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
                }
            },
            {
                title: "Saldo",
                data: null,
                render: (rowData) => {
                    const saldo = rowData.creditoSaldoActual != null ? rowData.creditoSaldoActual : (rowData.creditos?.[0]?.saldoActual || 0);
                    const valorFormateado = formatoMoneda(saldo);
                    return `<span style="text-align: right; display: block;">${valorFormateado}</span>`;
                }
            },
            {
                title: "Estado",
                data: null,
                render: (row) => {
                    let badgeClass = "";
                    const credito = row.creditos?.[0];
                    const estadoCredito = (row.creditoEstado || credito?.estado || row.estado || "Pendiente").trim();
                    const diasMora = Number(row.creditoDiasMora ?? credito?.diasMora ?? 0);
                    const enMora =
                        estadoCredito.toLowerCase() === "pendiente" &&
                        diasMora > 0;
                    const etiqueta = enMora ? "Mora" : estadoCredito;

                    switch (etiqueta) {
                        case "Completada":
                        case "Pagado":
                            badgeClass = "bg-success text-white";
                            break;
                        case "Anulada":
                        case "Cancelado":
                            badgeClass = "bg-info text-white";
                            break;
                        case "Pendiente":
                            badgeClass = "bg-warning text-white";
                            break;
                        case "Mora":
                            badgeClass = "bg-danger text-white";
                            break;
                        default:
                            badgeClass = "bg-secondary text-white";
                    }
                    const sufijo = enMora ? ` ${diasMora}d` : "";
                    return `<span class="badge ${badgeClass}">${etiqueta ?? "—"}${sufijo}</span>`;
                },
            },
            {
                title: "Acciones",
                data: null,
                orderable: false,
                className: "dt-center all",
                actions: [
                    {
                        key: "ver",
                        className: "btn btn-outline-primary btn-sm",
                        icon: "fas fa-eye",
                        title: "Ver Detalles",
                        onClick: (rowData) => handleSeleccionarVenta(rowData)
                    },
                    {
                        key: "imprimirReporteCredito",
                        className: "btn btn-outline-success btn-sm my-1",
                        icon: "fas fa-chart-bar",
                        title: "Reporte de Venta",
                        onClick: (rowData) => handleImprimirReporte(rowData)
                    }
                ]
            }
        ],
        []
    );

    const datos = {
        titulo: {
            titulo: "Gestion de Créditos",
            url: "/app/admin/ventas/gestionar",
            tituloUrl: "Ventas",
            nombreUrl: "Créditos",
        },
    };

    // El filtro por estado del credito es del lado del cliente: el backend
    // aplica `where.estado` sobre Ventas, no sobre Credito.
    const filtrarPorEstadoCredito = useCallback((ventas, estado) => {
        return (ventas || []).filter((v) => {
            const tieneCredito =
                v.tieneCredito ??
                (v.creditoId != null ||
                    (Array.isArray(v.creditos) && v.creditos.length > 0) ||
                    v.tipoVenta === "Credito");

            if (!tieneCredito) return false;

            const credito = Array.isArray(v.creditos) && v.creditos.length > 0 ? v.creditos[0] : null;
            const estadoCredito =
                (v.creditoEstado || credito?.estado || v.estado || "").trim();
            const diasMora = Number(
                v.creditoDiasMora ?? credito?.diasMora ?? 0
            );

            if (!estado || estado === "TODOS") return true;

            // "Mora" no existe como estado guardado: ningun credito lo tiene.
            // Es una condicion derivada, un pendiente que ya vencio. El
            // backend ya manda diasMora calculado (>0 solo en los vencidos).
            if (estado === "Mora") {
                return (
                    estadoCredito.toLowerCase() === "pendiente" &&
                    diasMora > 0
                );
            }

            const estadoNorm = estadoCredito.toUpperCase();
            const filtroNorm = estado.toUpperCase().trim();

            if (filtroNorm === "COMPLETADA") {
                return estadoNorm === "COMPLETADA" || estadoNorm === "PAGADO";
            }
            if (filtroNorm === "ANULADA") {
                return estadoNorm === "ANULADA" || estadoNorm === "CANCELADO";
            }
            if (filtroNorm === "PENDIENTE") {
                return estadoNorm === "PENDIENTE";
            }

            return estadoNorm === filtroNorm;
        });
    }, []);

    /**
     * Carga el rango en ventanas mensuales secuenciales y va pintando la
     * tabla mes a mes. Ver CargaPorRangos.js para el porque: el endpoint no
     * pagina y trae 10 relaciones por registro, asi que una consulta de
     * varios meses bloquea la API para todos los usuarios.
     */
    const obtenerCreditosFiltrados = async (
        estado,
        empleado,
        clienteId,
        finicio,
        ffin
    ) => {
        // Si habia una carga en vuelo se cancela: evita apilar consultas
        // pesadas cuando se filtra dos veces seguidas.
        if (refCarga.current) {
            refCarga.current.abort();
        }
        const control = new AbortController();
        refCarga.current = control;

        const desde = finicio || moment().startOf("isoWeek").format("YYYY-MM-DD");
        const hasta = ffin || moment().format("YYYY-MM-DD");

        mostrarAlertaLoading("Obteniendo créditos", "Preparando la consulta.");

        try {
            await cargarPorRangos({
                url: VentaFiltro,
                familia: "ventas",
                filtros: {
                    clienteId: clienteId || "",
                    empleadoId: empleado && empleado !== "TODOS" ? empleado : "",
                },
                desde,
                hasta,
                signal: control.signal,
                onLote: (acumulado, info) => {
                    // Render progresivo: la tabla se llena a medida que
                    // llega cada mes, en lugar de esperar todo el rango.
                    setCreditosFiltrados(filtrarPorEstadoCredito(acumulado, estado));
                    actualizarAlertaLoading(textoProgreso(info));
                },
            });

            cerrarAlerta();
        } catch (error) {
            // Carga reemplazada por otra mas reciente: no es un error.
            if (
                error.name === "CanceledError" ||
                error.code === "ERR_CANCELED" ||
                control.signal.aborted
            ) {
                return;
            }

            console.error(error);
            const esTimeout =
                error.code === "ECONNABORTED" ||
                (error.message || "").toLowerCase().includes("timeout");
            mostraAlertaError(
                esTimeout
                    ? "La consulta tardó demasiado. Reduzca el rango de fechas e intente de nuevo."
                    : "Error al obtener los créditos.",
                "Error"
            );
            setCreditosFiltrados([]);
        } finally {
            if (refCarga.current === control) {
                refCarga.current = null;
            }
        }
    };
    const handleFiltrar = () => {
        setPanelAbierto(false);
        setVentaSeleccionada(null);
        obtenerCreditosFiltrados(estadoFiltroTemp, empleadoFiltroTemp, selectedEvent?.clienteId, fechaInicio, fechaFin);

    };

    const handleClienteSeleccionado = (cliente) => {
        setSelectedEvent((prev) => ({
            ...prev,
            clienteId: cliente.id,
            clienteNombre: cliente.nombreCompleto,
        }));
        setModalClienteOpen(false);
    };

    const handleReset = () => {
        const inicio = moment()
            .subtract(RANGO_INICIAL_MESES, "months")
            .format("YYYY-MM-DD");
        const fin = moment().format("YYYY-MM-DD");
        setFechaInicio(inicio);
        setFechaFin(fin);
        setEstadoFiltroTemp("TODOS");
        setEmpleadoFiltroTemp("TODOS");
        setPanelAbierto(false);
        setSelectedEvent({});
        obtenerCreditosFiltrados("TODOS", "TODOS", null, inicio, fin);
    };

    const filteredClientes = clientes.filter((cliente) => {
        const searchTerm = clienteSearchTerm.trim().toLowerCase();

        // 1. Búsqueda por Nombre Completo del Cliente
        const nombreClienteMatch = cliente.nombreCompleto
            .toLowerCase()
            .includes(searchTerm);

        // 2. Búsqueda por Nombre de la Empresa del Cliente
        const nombreEmpresaMatch =
            cliente.ClienteEmpresas &&
            cliente.ClienteEmpresas.some((empresa) =>
                empresa.nombre.toLowerCase().includes(searchTerm)
            );

        // El cliente se incluye si coincide por nombre completo O por el nombre de alguna de sus empresas
        return nombreClienteMatch || nombreEmpresaMatch;
    });

    const [paginaCliente, setPaginaCliente] = useState(1);
    const clientesPorPagina = 5;
    const indexUltimoCliente = paginaCliente * clientesPorPagina;
    const indexPrimeroCliente = indexUltimoCliente - clientesPorPagina;
    const clientesPagina = filteredClientes.slice(indexPrimeroCliente, indexUltimoCliente);
    const totalPaginasCliente = Math.ceil(filteredClientes.length / clientesPorPagina);

    const obtenerLineasDePagoDetalladas = (pagoVentaItem, indice) => {
        const lineas = [];

        const datosBase = {
            fecha: pagoVentaItem.pago.fecha,
            documento: pagoVentaItem.pago.documento || `Abono #${indice + 1}`,
            pagoId: pagoVentaItem.pago.id,
        };

        let detalleEncontrado = false;

        pagoVentaItem.pago.pagoefectivos?.forEach((efectivo, idx) => {
            detalleEncontrado = true;
            const cambio = parseFloat(pagoVentaItem.pago.recibido || 0) - parseFloat(pagoVentaItem.pago.pago || 0);
            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-efectivo-${idx}`,
                metodo: "Efectivo",

                // dinero recibido del cliente
                monto: parseFloat(efectivo.monto || 0),

                // dinero aplicado a la venta
                aplicado: parseFloat(efectivo.monto - cambio || 0),

                // cambio entregado
                cambio: cambio,

                cssClass: "text-success",
            });
        });

        pagoVentaItem.pago.pagotarjeta?.forEach((tarjeta, idx) => {
            detalleEncontrado = true;

            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-tarjeta-${idx}`,
                metodo: "Tarjeta",
                monto: parseFloat(tarjeta.monto || 0),
                aplicado: parseFloat(tarjeta.monto || 0),
                cambio: 0,
                cssClass: "text-info",
            });
        });

        pagoVentaItem.pago.pagotransferencia?.forEach((transferencia, idx) => {
            detalleEncontrado = true;

            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-transferencia-${idx}`,
                metodo: "Transferencia",
                monto: parseFloat(transferencia.monto || 0),
                aplicado: parseFloat(transferencia.monto || 0),
                cambio: 0,
                cssClass: "text-primary",
            });
        });

        const montoPagoPrincipal = parseFloat(
            pagoVentaItem.pago.recibido || 0
        );

        if (!detalleEncontrado && montoPagoPrincipal > 0) {
            lineas.push({
                ...datosBase,
                key: `${pagoVentaItem.pago.id}-general`,
                metodo: "Pago General",
                monto: montoPagoPrincipal,
                cssClass: "text-warning",
            });
        }

        return lineas;
    };

    const todasLasLineasDePago =
        ventaSeleccionada?.pagoVenta
            ?.filter(item => item.pago?.estado !== "Anulada")
            .sort(
                (a, b) =>
                    new Date(a.pago.fecha) -
                    new Date(b.pago.fecha)
            )
            .flatMap((item, indice) =>
                obtenerLineasDePagoDetalladas(item, indice)
            ) || [];


    const documentoInfo = (() => {
        const numFactura =
            ventaSeleccionada?.numeroFacturaDoc ||
            ventaSeleccionada?.numeroFactura ||
            ventaSeleccionada?.facturas?.[0]?.numeroFactura;

        if (numFactura) {
            return {
                tipo: "Factura",
                numero: numFactura,
                badge: "bg-primary"
            };
        }

        const numRecibo =
            ventaSeleccionada?.numeroReciboDoc ||
            ventaSeleccionada?.recibos?.[0]?.id;

        if (numRecibo) {
            return {
                tipo: "Recibo",
                numero: numRecibo,
                badge: "bg-info"
            };
        }

        return null;
    })();
    return (
        <Page datos={datos}>
            <Card titulo="Listado de ventas - Credito">
                <div className="mb-4 d-flex justify-content-end">
                    <div className="position-relative">
                        {/* Botón para Abrir/Cerrar Panel */}
                        <button
                            className={`btn ${panelAbierto ? "btn-danger" : "btn-primary"} d-flex justify-content-between align-items-center`}
                            onClick={() => setPanelAbierto(!panelAbierto)}
                            style={{
                                borderRadius: "6px",
                                padding: "6px 12px",
                                fontSize: "0.9rem",
                                minWidth: "140px",
                            }}
                        >
                            <span className="d-flex align-items-center">
                                <i className="fas fa-filter mx-2"></i>
                                Filtros
                            </span>
                            <i className={`fas fa-chevron-${panelAbierto ? "up" : "down"}`}></i>
                        </button>

                        {/* Panel de Filtros */}
                        {panelAbierto && (
                            <div
                                className="position-absolute top-100 mt-2 bg-body border border-secondary-subtle text-body shadow"
                                style={{
                                    minWidth: "240px",
                                    right: 0,
                                    borderRadius: "10px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    padding: "15px",
                                    zIndex: 1050,
                                }}
                            >
                                <div className="mb-3">
                                    <label className="form-label">Fecha inicio</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaInicio}
                                        onChange={(e) => setFechaInicio(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Fecha fin</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-sm"
                                        value={fechaFin}
                                        onChange={(e) => setFechaFin(e.target.value)}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Cliente</label>
                                    <div className="d-flex align-items-center">
                                        {selectedEvent.clienteNombre ? (
                                            <span className="text-success fw-bold">{selectedEvent.clienteNombre}</span>
                                        ) : (
                                            <span className="text-muted">Ninguno seleccionado</span>
                                        )}
                                    </div>
                                    <ModalBootstrap
                                        titulo="Seleccionar cliente"
                                        nombreBoton="Buscar"
                                        estiloBoton="btn btn-sm btn-outline-primary mt-2"
                                        iconBoton="fa-solid fa-magnifying-glass"
                                        modalIsOpen={modalClienteOpen}
                                        setModalIsOpen={setModalClienteOpen}
                                    >
                                        <div className="mb-3">
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Buscar cliente..."
                                                value={clienteSearchTerm}
                                                onChange={(e) => setClienteSearchTerm(e.target.value)}
                                            />
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-bordered table-striped table-hover shadow-smr">
                                                <thead className="bg-dark text-white">
                                                    <tr>
                                                        <th>ID</th>
                                                        <th>Empresas</th>
                                                        <th>Nombre completo</th>
                                                        <th>Agregar</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {clientesPagina.length > 0 ? (
                                                        clientesPagina.map((cliente) => (
                                                            <tr key={cliente.id}>
                                                                <td>{cliente.id}</td>
                                                                <td className="align-middle">
                                                                    {cliente.ClienteEmpresas && cliente.ClienteEmpresas.length > 0
                                                                        ? cliente.ClienteEmpresas.map((empresa, index) => (
                                                                            <div key={index} className="mb-1">
                                                                                {empresa.nombre}
                                                                            </div>
                                                                        ))
                                                                        : "N/A"}
                                                                </td>
                                                                <td>{cliente.nombreCompleto}</td>
                                                                <td className="text-center align-middle">
                                                                    <button
                                                                        className="btn btn-success btn-sm"
                                                                        onClick={() =>
                                                                            handleClienteSeleccionado(cliente)
                                                                        }
                                                                    >
                                                                        <i className="fa-regular fa-square-check" />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="3" className="text-center text-muted">
                                                                No se encontraron clientes.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            <div className="d-flex justify-content-center">
                                                <nav className="mt-2">
                                                    <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                                        {/* Botón "Anterior" */}
                                                        <li className={`page-item ${paginaCliente === 1 ? "disabled" : ""}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setPaginaCliente(paginaCliente - 1)}
                                                                aria-label="Anterior"
                                                            >
                                                                <i className="fas fa-chevron-left me-1"></i> Anterior
                                                            </button>
                                                        </li>

                                                        {
                                                            (() => {
                                                                const pagesToShow = 5;
                                                                const halfPages = Math.floor(pagesToShow / 2);
                                                                let startPage = Math.max(1, paginaCliente - halfPages);
                                                                let endPage = Math.min(totalPaginasCliente, paginaCliente + halfPages);

                                                                if (paginaCliente <= halfPages) {
                                                                    endPage = Math.min(totalPaginasCliente, pagesToShow);
                                                                }
                                                                if (paginaCliente > totalPaginasCliente - halfPages) {
                                                                    startPage = Math.max(1, totalPaginasCliente - pagesToShow + 1);
                                                                }

                                                                const pageButtons = [];
                                                                for (let i = startPage; i <= endPage; i++) {
                                                                    pageButtons.push(
                                                                        <li
                                                                            key={i}
                                                                            className={`page-item ${paginaCliente === i ? "active" : ""}`}
                                                                        >
                                                                            <button className="page-link fw-bold" onClick={() => setPaginaCliente(i)}>
                                                                                {i}
                                                                            </button>
                                                                        </li>
                                                                    );
                                                                }
                                                                return pageButtons;
                                                            })()
                                                        }

                                                        {/* Botón "Siguiente" */}
                                                        <li className={`page-item ${paginaCliente === totalPaginasCliente ? "disabled" : ""}`}>
                                                            <button
                                                                className="page-link"
                                                                onClick={() => setPaginaCliente(paginaCliente + 1)}
                                                                aria-label="Siguiente"
                                                            >
                                                                Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        </div>
                                    </ModalBootstrap>
                                </div>
                                <div className="form-group mb-3">
                                    <label className="form-label fw-bold">
                                        Empleado
                                    </label>

                                    <select
                                        className="form-control form-control-sm"
                                        value={empleadoFiltroTemp}
                                        onChange={(e) =>
                                            setEmpleadoFiltroTemp(e.target.value)
                                        }
                                    >
                                        <option value="TODOS">
                                            Todos los empleados
                                        </option>

                                        {listaEmpleados?.map((empleado) => (
                                            <option
                                                key={empleado.id}
                                                value={empleado.id}
                                            >
                                                {empleado.nombreCompleto}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="form-group mb-3">
                                    <label htmlFor="estadoFiltroSelect" className="form-label fw-bold">Estado</label>
                                    <select
                                        id="estadoFiltroSelect"
                                        className="form-control form-control-sm"
                                        value={estadoFiltroTemp}
                                        onChange={(e) => setEstadoFiltroTemp(e.target.value)}
                                    >
                                        <option value="TODOS">Todos</option>
                                        <option value="Pendiente">Pendiente</option>
                                        <option value="Completada">Completada</option>
                                        <option value="Anulada">Anulada</option>
                                        <option value="Mora">Mora</option>
                                    </select>
                                </div>

                                {/* Botones de Acción */}
                                <div className="d-flex justify-content-end">
                                    {/* *** Aplica el filtro con el valor temporal *** */}
                                    <button className="btn btn-sm btn-primary mx-2" onClick={handleFiltrar}>
                                        <i className="fas fa-filter mx-1"></i> Filtrar
                                    </button>
                                    {/* *** Resetea a Facturas *** */}
                                    <button className="btn btn-sm btn-secondary" onClick={handleReset}>
                                        <i className="fas fa-sync-alt mx-1"></i> Reset
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <Tablas
                    datos={creditosFiltrados}
                    columnas={columnas}
                    id="tablaVentasCreditos"
                />
            </Card>
            {ventaSeleccionada && (
                <div ref={refEdicion} className="mt-4">
                    <Card
                        titulo="Detalle de Venta"
                        className="p-4 shadow-lg rounded"
                        pie={
                            <>
                                {ventaSeleccionada?.ventanuladas?.length > 0 ? (
                                    <div className="card border-danger shadow-sm mt-3">

                                        <div className="card-header bg-danger text-white">

                                            <div className="d-flex align-items-center">

                                                <i className="fas fa-ban mr-2"></i>

                                                <strong>
                                                    Venta Anulada
                                                </strong>

                                            </div>

                                        </div>

                                        <div className="card-body">

                                            <div className="row">

                                                <div className="col-md-6 mb-3">

                                                    <small className="text-muted d-block">
                                                        Motivo de Anulación
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {
                                                            ventaSeleccionada.ventanuladas[0]
                                                                .descripcion
                                                        }
                                                    </div>

                                                </div>

                                                <div className="col-md-6 mb-3">

                                                    <small className="text-muted d-block">
                                                        Responsable
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {
                                                            ventaSeleccionada.ventanuladas[0]
                                                                .Empleado?.nombreCompleto
                                                        }
                                                    </div>

                                                </div>

                                                <div className="col-md-6">

                                                    <small className="text-muted d-block">
                                                        Fecha de Anulación
                                                    </small>

                                                    <div className="font-weight-bold">
                                                        {moment(
                                                            ventaSeleccionada
                                                                .ventanuladas[0]
                                                                .fechaHora
                                                        ).format(
                                                            "DD/MM/YYYY HH:mm"
                                                        )}
                                                    </div>

                                                </div>

                                                <div className="col-md-6">

                                                    <small className="text-muted d-block">
                                                        Estado
                                                    </small>

                                                    <span className="badge badge-danger">
                                                        ANULADA
                                                    </span>

                                                </div>

                                            </div>

                                        </div>

                                    </div>
                                ) : saldoPendiente > 0 ? (
                                    <ModalWizardBootstrap
                                        titulo={`Registrar abono a crédito #${ventaSeleccionada?.id || "..."}`}
                                        modalIsOpen={modalOpen2}
                                        setModalIsOpen={setModalOpen2}
                                        nombreBoton={`Abonar ${formatoMoneda(saldoPendiente)}`}
                                        estiloBoton="btn btn-success mx-3"
                                        iconBoton="fas fa-hand-holding-usd mx-2"
                                        iconos={[
                                            "fas fa-receipt",
                                            "fas fa-check-circle",
                                        ]}
                                        onFinish={confirmarPagoCredito}
                                        pasos={[
                                            {
                                                etiqueta: "Nuevo Pago",
                                                contenido: (
                                                    <>
                                                        <p className="mt-3">
                                                            <strong>Total venta:</strong> {formatoMoneda(totalVenta)}<br />
                                                            <strong>Total abonado:</strong> {formatoMoneda(totalPagado)}<br />
                                                            <strong>Saldo pendiente:</strong> {formatoMoneda(saldoPendiente)}
                                                        </p>
                                                        <MetodosPagoDinamicos
                                                            efectivo={efectivo}
                                                            setEfectivo={setEfectivo}
                                                            montosPos={montosPos}
                                                            setMontosPos={setMontosPos}
                                                            referenciasPos={referenciasPos}
                                                            setReferenciasPos={setReferenciasPos}
                                                            erroresReferenciaPos={erroresReferenciaPos}
                                                            setErroresReferenciaPos={setErroresReferenciaPos}
                                                            montosTransferencia={montosTransferencia}
                                                            setMontosTransferencia={setMontosTransferencia}
                                                            referenciasTransferencia={referenciasTransferencia}
                                                            setReferenciasTransferencia={setReferenciasTransferencia}
                                                            erroresReferenciaTransferencia={erroresReferenciaTransferencia}
                                                            setErroresReferenciaTransferencia={setErroresReferenciaTransferencia}
                                                            pos={pos}
                                                            setPos={setPos}
                                                            transferencias={transferencias}
                                                            setTransferencias={setTransferencias}
                                                            formatoMoneda={formatoMoneda}
                                                            totalConRecargo={saldoPendiente}
                                                            totalRecibido={totalRecibido}
                                                        />
                                                    </>
                                                ),
                                            },
                                            {
                                                etiqueta: "Confirmación",
                                                contenido: (
                                                    <div className="text-center">
                                                        <i className="fas fa-check-circle fa-3x text-success mb-2" />
                                                        <p>¡Todo listo para un nuevo pago!</p>
                                                    </div>
                                                ),
                                            },
                                        ]}
                                    />
                                ) : (
                                    <div className="alert alert-info mt-3">
                                        <i className="fas fa-info-circle mx-2"></i>
                                        No se puede anular el pago porque la venta a crédito ya fue pagada por completo.
                                    </div>
                                )}
                            </>
                        }
                    >
                        {ventaSeleccionada.ventadetallepedidos?.length > 0 ? (
                            <div className="container-fluid">
                                <div className="row justify-content-center">
                                    <div className="col-12">

                                        {/* ENCABEZADO */}
                                        <div className="card border-0 shadow-sm">

                                            <div className="card-header py-4">

                                                <div className="row mb-4">

                                                    <div className="col-md-8">

                                                        <h2 className="h3 mb-2 text-primary fw-bold">
                                                            Informe de Auditoría de Venta
                                                        </h2>

                                                        <p className="text-secondary mb-2">
                                                            Venta #{ventaSeleccionada.id}
                                                        </p>

                                                        <div>

                                                            {documentoInfo && (
                                                                <span
                                                                    className={`badge mr-2 ${documentoInfo.badge}`}
                                                                >
                                                                    {documentoInfo.tipo}: {documentoInfo.numero}
                                                                </span>
                                                            )}

                                                            {(ventaSeleccionada.creditoId || ventaSeleccionada.creditos?.[0]?.id) && (
                                                                <span className="badge bg-warning mr-2">
                                                                    Crédito #{ventaSeleccionada.creditoId || ventaSeleccionada.creditos[0].id}
                                                                </span>
                                                            )}

                                                        </div>

                                                    </div>

                                                    <div className="col-md-4 text-md-right mt-3 mt-md-0">

                                                        <h4 className="mb-1 ">
                                                            Crédito
                                                        </h4>

                                                        <p className="text-secondary mb-2">

                                                            Estado de la Venta

                                                        </p>

                                                        <span
                                                            className={`badge px-3 py-2 ${ventaSeleccionada.estado === "Completada"
                                                                ? "bg-success"
                                                                : ventaSeleccionada.estado === "Anulada"
                                                                    ? "bg-danger"
                                                                    : "bg-warning"
                                                                }`}
                                                        >
                                                            {ventaSeleccionada.estado}
                                                        </span>

                                                    </div>

                                                </div>

                                                <hr className="border-secondary opacity-50 my-4" />

                                                <div className="row">

                                                    {/* INFORMACIÓN DEL CLIENTE */}

                                                    <div className="col-md-6 text-md-left mt-4 mt-md-0">

                                                        <div className="row">
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Cliente
                                                                </small>


                                                                <strong>
                                                                    {ventaSeleccionada.Cliente?.ClienteEmpresas?.[0]?.nombre ||
                                                                        ventaSeleccionada.clienteNombre ||
                                                                        ventaSeleccionada.Cliente?.nombreCompleto ||
                                                                        "N/A"}
                                                                </strong>

                                                            </div>
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    RTN
                                                                </small>


                                                                <strong>
                                                                    {ventaSeleccionada.rtn || "N/A"}
                                                                </strong>

                                                            </div>
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Tipo de Venta
                                                                </small>


                                                                <strong>
                                                                    {ventaSeleccionada.tipoVenta || "N/A"}
                                                                </strong>

                                                            </div>
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Vendedor
                                                                </small>


                                                                <strong>
                                                                    {ventaSeleccionada.empleadoNombre || ventaSeleccionada.Empleado?.nombreCompleto || "N/A"}
                                                                </strong>

                                                            </div>
                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Caja
                                                                </small>

                                                                <strong>
                                                                    {ventaSeleccionada.cajaNombre || ventaSeleccionada.caja?.nombre || "N/A"}
                                                                </strong>
                                                            </div>

                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Dispositivo
                                                                </small>

                                                                <strong>
                                                                    {ventaSeleccionada.cajaDispositivo || ventaSeleccionada.caja?.estacione?.dispositivo || "N/A"}
                                                                </strong>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    {/* INFORMACIÓN DEL DOCUMENTO */}

                                                    <div className="col-md-6 text-md-right mt-4 mt-md-0">

                                                        <div className="row">

                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    {documentoInfo
                                                                        ? `${documentoInfo.tipo}`
                                                                        : "Documento"}
                                                                </small>

                                                                <strong>
                                                                    {documentoInfo
                                                                        ? `#${documentoInfo.numero}`
                                                                        : "N/A"}
                                                                </strong>
                                                            </div>

                                                            <div className="col-6 mb-2">
                                                                <small className="text-secondary d-block">
                                                                    Pedido
                                                                </small>

                                                                <strong>
                                                                    #
                                                                    {ventaSeleccionada.ventapedidos?.[0]?.pedidoId || "N/A"}
                                                                </strong>
                                                            </div>

                                                            {(ventaSeleccionada.creditoId || ventaSeleccionada.creditos?.[0]) && (
                                                                <>
                                                                    <div className="col-6 mb-2">
                                                                        <small className="text-secondary d-block">
                                                                            Estado Crédito
                                                                        </small>

                                                                        <strong
                                                                            className={
                                                                                (ventaSeleccionada.creditoEstado || ventaSeleccionada.creditos?.[0]?.estado) === "Pendiente"
                                                                                    ? "text-warning"
                                                                                    : "text-success"
                                                                            }
                                                                        >
                                                                            {ventaSeleccionada.creditoEstado || ventaSeleccionada.creditos?.[0]?.estado || "N/A"}
                                                                        </strong>
                                                                    </div>

                                                                    <div className="col-6 mb-2">
                                                                        <small className="text-secondary d-block">
                                                                            Días Mora
                                                                        </small>

                                                                        <strong
                                                                            className={
                                                                                Number(ventaSeleccionada.creditoDiasMora ?? ventaSeleccionada.creditos?.[0]?.diasMora ?? 0) > 0
                                                                                    ? "text-danger"
                                                                                    : "text-success"
                                                                            }
                                                                        >
                                                                            {ventaSeleccionada.creditoDiasMora ?? ventaSeleccionada.creditos?.[0]?.diasMora ?? 0}
                                                                        </strong>
                                                                    </div>

                                                                    <div className="col-6 mb-2">
                                                                        <small className="text-secondary d-block">
                                                                            Fecha Registro
                                                                        </small>

                                                                        <strong>
                                                                            {moment(
                                                                                ventaSeleccionada.creditoFecha ||
                                                                                ventaSeleccionada.creditos?.[0]?.fecha ||
                                                                                ventaSeleccionada.createdAt
                                                                            ).format("DD/MM/YYYY")}
                                                                        </strong>
                                                                    </div>

                                                                    <div className="col-6 mb-2">
                                                                        <small className="text-secondary d-block">
                                                                            Vencimiento
                                                                        </small>

                                                                        <strong>
                                                                            {moment(
                                                                                ventaSeleccionada.creditoVencimiento ||
                                                                                ventaSeleccionada.creditos?.[0]?.fechaVencimiento
                                                                            ).format("DD/MM/YYYY")}
                                                                        </strong>
                                                                    </div>
                                                                </>
                                                            )}

                                                        </div>

                                                    </div>

                                                </div>
                                            </div>

                                            <div className="card-body">

                                                {(() => {

                                                    const totalVenta = ventaSeleccionada.ventadetallepedidos
                                                        ? ventaSeleccionada.ventadetallepedidos.reduce(
                                                            (sum, item) =>
                                                                sum +
                                                                item.cantidad * parseFloat(item.precio || 0),
                                                            0
                                                        )
                                                        : parseFloat(ventaSeleccionada.totalVenta || 0);

                                                    const totalPagado =
                                                        ventaSeleccionada.pagoVenta
                                                            ?.filter(p => p.pago.estado !== "Anulada")
                                                            .reduce(
                                                                (sum, p) =>
                                                                    sum +
                                                                    parseFloat(
                                                                        p.pago.pago || 0
                                                                    ),
                                                                0
                                                            ) || 0;

                                                    const saldoPendiente = Math.max(
                                                        totalVenta - totalPagado,
                                                        0
                                                    );

                                                    return (
                                                        <>
                                                            {/* KPI */}

                                                            {/* PRODUCTOS */}
                                                            <div className="card shadow-sm mb-4">

                                                                <div className="card-header">
                                                                    <h5 className="mb-0 font-weight-bold">
                                                                        Detalle de Productos Vendidos
                                                                    </h5>
                                                                </div>

                                                                <div className="card-body p-0">

                                                                    <div className="table-responsive">

                                                                        <table className="table align-middle mb-0">

                                                                            <thead>

                                                                                <tr>

                                                                                    <th
                                                                                        className="border-top-0"
                                                                                        style={{ width: "60px" }}
                                                                                    >
                                                                                        #
                                                                                    </th>

                                                                                    <th className="border-top-0">
                                                                                        Descripción
                                                                                    </th>

                                                                                    <th
                                                                                        className="border-top-0 text-right"
                                                                                        style={{ width: "120px" }}
                                                                                    >
                                                                                        Cantidad
                                                                                    </th>

                                                                                    <th
                                                                                        className="border-top-0 text-right"
                                                                                        style={{ width: "150px" }}
                                                                                    >
                                                                                        Precio Unitario
                                                                                    </th>

                                                                                    <th
                                                                                        className="border-top-0 text-right"
                                                                                        style={{ width: "150px" }}
                                                                                    >
                                                                                        Descuento
                                                                                    </th>

                                                                                    <th
                                                                                        className="border-top-0 text-right"
                                                                                        style={{ width: "180px" }}
                                                                                    >
                                                                                        Subtotal
                                                                                    </th>

                                                                                </tr>

                                                                            </thead>

                                                                            <tbody>

                                                                                {ventaSeleccionada.ventadetallepedidos.map(
                                                                                    (detalle, index) => {

                                                                                        const subtotal =
                                                                                            detalle.cantidad *
                                                                                            parseFloat(
                                                                                                detalle.precio || 0
                                                                                            );

                                                                                        return (
                                                                                            <tr key={index}>

                                                                                                <td>
                                                                                                    {index + 1}
                                                                                                </td>

                                                                                                <td>

                                                                                                    <div className="mb-2">

                                                                                                        <span className="badge badge-secondary mr-1">
                                                                                                            ID {detalle.producto?.id}
                                                                                                        </span>

                                                                                                        <span className="badge badge-dark">
                                                                                                            {detalle.producto?.codigo}
                                                                                                        </span>

                                                                                                    </div>

                                                                                                    <p className="mb-0 font-weight-bold">
                                                                                                        {detalle.producto?.nombre}
                                                                                                    </p>

                                                                                                    {detalle.tipoImpuesto && (
                                                                                                        <small className="text-muted">
                                                                                                            Impuesto: {detalle.tipoImpuesto}
                                                                                                        </small>
                                                                                                    )}

                                                                                                </td>

                                                                                                <td className="text-right">
                                                                                                    {detalle.cantidad}
                                                                                                </td>

                                                                                                <td className="text-right">
                                                                                                    {formatoMoneda(
                                                                                                        detalle.precio
                                                                                                    )}
                                                                                                </td>

                                                                                                <td className="text-right text-muted">
                                                                                                    {formatoMoneda(
                                                                                                        detalle.descuento
                                                                                                    )}
                                                                                                </td>

                                                                                                <td className="text-right font-weight-bold">
                                                                                                    {formatoMoneda(
                                                                                                        subtotal
                                                                                                    )}
                                                                                                </td>

                                                                                            </tr>
                                                                                        );
                                                                                    }
                                                                                )}

                                                                            </tbody>

                                                                            <tfoot>

                                                                                <tr>

                                                                                    <td
                                                                                        colSpan="5"
                                                                                        className="text-right font-weight-bold border-top"
                                                                                    >
                                                                                        Subtotal
                                                                                    </td>

                                                                                    <td className="text-right border-top">
                                                                                        {formatoMoneda(
                                                                                            ventaSeleccionada.subtotal
                                                                                        )}
                                                                                    </td>

                                                                                </tr>

                                                                                <tr>

                                                                                    <td
                                                                                        colSpan="5"
                                                                                        className="text-right font-weight-bold"
                                                                                    >
                                                                                        ISV 15%
                                                                                    </td>

                                                                                    <td className="text-right">
                                                                                        {formatoMoneda(
                                                                                            ventaSeleccionada.impuesto15
                                                                                        )}
                                                                                    </td>

                                                                                </tr>

                                                                                {Number(
                                                                                    ventaSeleccionada.impuesto18 || 0
                                                                                ) > 0 && (

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="5"
                                                                                                className="text-right font-weight-bold"
                                                                                            >
                                                                                                ISV 18%
                                                                                            </td>

                                                                                            <td className="text-right">
                                                                                                {formatoMoneda(
                                                                                                    ventaSeleccionada.impuesto18
                                                                                                )}
                                                                                            </td>

                                                                                        </tr>

                                                                                    )}

                                                                                {Number(
                                                                                    ventaSeleccionada.exento || 0
                                                                                ) > 0 && (

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="5"
                                                                                                className="text-right font-weight-bold"
                                                                                            >
                                                                                                Exento
                                                                                            </td>

                                                                                            <td className="text-right">
                                                                                                {formatoMoneda(
                                                                                                    ventaSeleccionada.exento
                                                                                                )}
                                                                                            </td>

                                                                                        </tr>

                                                                                    )}

                                                                                {Number(
                                                                                    ventaSeleccionada.exonerado || 0
                                                                                ) > 0 && (

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="5"
                                                                                                className="text-right font-weight-bold"
                                                                                            >
                                                                                                Exonerado
                                                                                            </td>

                                                                                            <td className="text-right">
                                                                                                {formatoMoneda(
                                                                                                    ventaSeleccionada.exonerado
                                                                                                )}
                                                                                            </td>

                                                                                        </tr>

                                                                                    )}

                                                                                <tr>

                                                                                    <td
                                                                                        colSpan="5"
                                                                                        className="text-right font-weight-bold h6 border-top"
                                                                                    >
                                                                                        TOTAL FACTURADO
                                                                                    </td>

                                                                                    <td className="text-right font-weight-bold h6 border-top text-primary">
                                                                                        {formatoMoneda(
                                                                                            ventaSeleccionada.totalVenta
                                                                                        )}
                                                                                    </td>

                                                                                </tr>

                                                                            </tfoot>

                                                                        </table>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            <div className="row">

                                                                {/* CONCILIACION */}
                                                                <div className="col-lg-4 mb-4">

                                                                    <div className="card shadow-sm border-primary">

                                                                        <div className="card-header bg-primary text-white">
                                                                            Conciliación Financiera
                                                                        </div>

                                                                        <div className="card-body">

                                                                            <div className="d-flex justify-content-between mb-3">
                                                                                <span>
                                                                                    Total Facturado
                                                                                </span>

                                                                                <strong>
                                                                                    {formatoMoneda(
                                                                                        totalVenta
                                                                                    )}
                                                                                </strong>
                                                                            </div>

                                                                            <div className="d-flex justify-content-between mb-3">
                                                                                <span>
                                                                                    Total Pagado
                                                                                </span>

                                                                                <strong className="text-success">
                                                                                    {formatoMoneda(
                                                                                        totalPagado
                                                                                    )}
                                                                                </strong>
                                                                            </div>

                                                                            <hr />

                                                                            <div className="d-flex justify-content-between">

                                                                                <span className="fw-bold">
                                                                                    Saldo Pendiente
                                                                                </span>

                                                                                <span
                                                                                    className={`fw-bold fs-4 ${saldoPendiente > 0
                                                                                        ? "text-danger"
                                                                                        : "text-success"
                                                                                        }`}
                                                                                >
                                                                                    {formatoMoneda(
                                                                                        saldoPendiente
                                                                                    )}
                                                                                </span>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                    {/* DATOS AUDITORIA */}

                                                                    <div className="card shadow-sm mt-3">

                                                                        <div className="card-header bg-info text-white">
                                                                            Información de Auditoría
                                                                        </div>

                                                                        <div className="card-body">

                                                                            <p>
                                                                                <strong>Productos:</strong>{" "}
                                                                                {
                                                                                    ventaSeleccionada
                                                                                        .ventadetallepedidos
                                                                                        .length
                                                                                }
                                                                            </p>

                                                                            <p className="mb-0">
                                                                                <strong>
                                                                                    Registros de pago:
                                                                                </strong>{" "}
                                                                                {
                                                                                    ventaSeleccionada
                                                                                        .pagoVenta
                                                                                        ?.length
                                                                                }
                                                                            </p>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                                {/* PAGOS */}
                                                                <div className="col-lg-8">

                                                                    <div className="card shadow-sm">

                                                                        <div className="card-header">
                                                                            <h5 className="mb-0 font-weight-bold">
                                                                                Libro Auxiliar de Pagos
                                                                            </h5>
                                                                        </div>

                                                                        <div className="card-body p-0">

                                                                            <div className="table-responsive">

                                                                                <table className="table align-middle mb-0">

                                                                                    <thead>

                                                                                        <tr>

                                                                                            <th
                                                                                                className="border-top-0"
                                                                                                style={{ width: "100px" }}
                                                                                            >
                                                                                                Pago
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0"
                                                                                                style={{ width: "170px" }}
                                                                                            >
                                                                                                Fecha
                                                                                            </th>

                                                                                            <th className="border-top-0">
                                                                                                Método
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0 text-right"
                                                                                                style={{ width: "140px" }}
                                                                                            >
                                                                                                Recibido
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0 text-right"
                                                                                                style={{ width: "140px" }}
                                                                                            >
                                                                                                Cambio
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0 text-right"
                                                                                                style={{ width: "140px" }}
                                                                                            >
                                                                                                Aplicado
                                                                                            </th>

                                                                                        </tr>

                                                                                    </thead>

                                                                                    <tbody>

                                                                                        {todasLasLineasDePago.length > 0 ? (

                                                                                            todasLasLineasDePago.map(
                                                                                                linea => (

                                                                                                    <tr key={linea.key}>

                                                                                                        <td>

                                                                                                            <p className="mb-0 font-weight-bold">
                                                                                                                #{linea.pagoId}
                                                                                                            </p>

                                                                                                            <small className="text-muted">
                                                                                                                {linea.documento}
                                                                                                            </small>

                                                                                                        </td>

                                                                                                        <td>

                                                                                                            <div>
                                                                                                                {moment(
                                                                                                                    linea.fecha
                                                                                                                ).format(
                                                                                                                    "DD/MM/YYYY"
                                                                                                                )}
                                                                                                            </div>

                                                                                                            <small className="text-muted">
                                                                                                                {moment(
                                                                                                                    linea.fecha
                                                                                                                ).format(
                                                                                                                    "HH:mm"
                                                                                                                )}
                                                                                                            </small>

                                                                                                        </td>

                                                                                                        <td>

                                                                                                            <span
                                                                                                                className={`badge ${linea.metodo === "Efectivo"
                                                                                                                    ? "badge-success"
                                                                                                                    : linea.metodo === "Tarjeta"
                                                                                                                        ? "badge-info"
                                                                                                                        : linea.metodo === "Transferencia"
                                                                                                                            ? "badge-primary"
                                                                                                                            : "badge-secondary"
                                                                                                                    }`}
                                                                                                            >
                                                                                                                {linea.metodo}
                                                                                                            </span>

                                                                                                        </td>

                                                                                                        <td className="text-right font-weight-bold">

                                                                                                            {formatoMoneda(
                                                                                                                linea.monto
                                                                                                            )}

                                                                                                        </td>

                                                                                                        <td className="text-right text-danger">

                                                                                                            {Number(
                                                                                                                linea.cambio || 0
                                                                                                            ) > 0
                                                                                                                ? formatoMoneda(
                                                                                                                    linea.cambio
                                                                                                                )
                                                                                                                : "-"}

                                                                                                        </td>

                                                                                                        <td className="text-right font-weight-bold text-success">

                                                                                                            {formatoMoneda(
                                                                                                                linea.aplicado
                                                                                                            )}

                                                                                                        </td>

                                                                                                    </tr>

                                                                                                )
                                                                                            )

                                                                                        ) : (

                                                                                            <tr>

                                                                                                <td
                                                                                                    colSpan="6"
                                                                                                    className="text-center text-muted py-4"
                                                                                                >
                                                                                                    No existen pagos registrados.
                                                                                                </td>

                                                                                            </tr>

                                                                                        )}

                                                                                    </tbody>

                                                                                    <tfoot>

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="5"
                                                                                                className="text-right font-weight-bold border-top"
                                                                                            >
                                                                                                Total Aplicado
                                                                                            </td>

                                                                                            <td className="text-right font-weight-bold text-success border-top">

                                                                                                {formatoMoneda(totalPagado)}

                                                                                            </td>

                                                                                        </tr>

                                                                                    </tfoot>

                                                                                </table>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </div>

                                                            {/* ANULADOS */}

                                                            {ventaSeleccionada.pagoVenta?.filter(
                                                                p => p.pago.estado === "Anulada"
                                                            ).length > 0 && (

                                                                    <div className="card shadow-sm mt-4 border-danger">

                                                                        <div className="card-header">

                                                                            <div className="d-flex justify-content-between align-items-center">

                                                                                <div>

                                                                                    <h5 className="mb-0 text-danger font-weight-bold">
                                                                                        Pagos Anulados
                                                                                    </h5>

                                                                                    <small className="text-muted">
                                                                                        Movimientos excluidos de la conciliación financiera y del cálculo del saldo pendiente.
                                                                                    </small>

                                                                                </div>

                                                                                <span className="badge badge-danger">
                                                                                    {
                                                                                        ventaSeleccionada.pagoVenta.filter(
                                                                                            p => p.pago.estado === "Anulada"
                                                                                        ).length
                                                                                    } Anulado(s)
                                                                                </span>

                                                                            </div>

                                                                        </div>

                                                                        <div className="card-body p-0">

                                                                            <div className="table-responsive">

                                                                                <table className="table align-middle mb-0">

                                                                                    <thead>

                                                                                        <tr>

                                                                                            <th className="border-top-0">
                                                                                                Pago
                                                                                            </th>

                                                                                            <th className="border-top-0">
                                                                                                Fecha
                                                                                            </th>

                                                                                            <th className="border-top-0">
                                                                                                Motivo
                                                                                            </th>

                                                                                            <th className="border-top-0">
                                                                                                Método
                                                                                            </th>

                                                                                            <th
                                                                                                className="border-top-0 text-right"
                                                                                                style={{ width: "180px" }}
                                                                                            >
                                                                                                Monto
                                                                                            </th>

                                                                                        </tr>

                                                                                    </thead>

                                                                                    <tbody>

                                                                                        {ventaSeleccionada.pagoVenta
                                                                                            .filter(
                                                                                                p =>
                                                                                                    p.pago.estado ===
                                                                                                    "Anulada"
                                                                                            )
                                                                                            .map(p => (

                                                                                                <tr key={p.pago.id}>

                                                                                                    <td>

                                                                                                        <p className="mb-0 font-weight-bold">
                                                                                                            #{p.pago.id}
                                                                                                        </p>

                                                                                                        <small className="text-danger">
                                                                                                            Anulado
                                                                                                        </small>

                                                                                                    </td>

                                                                                                    <td>

                                                                                                        <div>
                                                                                                            {moment(
                                                                                                                p.pago.fecha
                                                                                                            ).format(
                                                                                                                "DD/MM/YYYY"
                                                                                                            )}
                                                                                                        </div>

                                                                                                        <small className="text-muted">
                                                                                                            {moment(
                                                                                                                p.pago.fecha
                                                                                                            ).format(
                                                                                                                "HH:mm"
                                                                                                            )}
                                                                                                        </small>

                                                                                                    </td>

                                                                                                    <td>

                                                                                                        <p className="mb-0">
                                                                                                            {p.pago.pagoanulados[0].descripcion || "Sin motivo"}
                                                                                                        </p>
                                                                                                        <small className="text-muted">
                                                                                                            {p.pago.pagoanulados[0].Empleado?.nombreCompleto || "Desconocido"}
                                                                                                        </small>

                                                                                                    </td>

                                                                                                    <td>

                                                                                                        {p.pago.pagoefectivos?.length > 0 && (
                                                                                                            <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                <span>
                                                                                                                    <span className="badge badge-success mr-2">
                                                                                                                        Efectivo
                                                                                                                    </span>
                                                                                                                </span>

                                                                                                                <strong>
                                                                                                                    {formatoMoneda(
                                                                                                                        p.pago.pagoefectivos.reduce(
                                                                                                                            (s, e) => s + Number(e.monto || 0),
                                                                                                                            0
                                                                                                                        )
                                                                                                                    )}
                                                                                                                </strong>

                                                                                                            </div>
                                                                                                        )}

                                                                                                        {p.pago.pagotarjeta?.length > 0 && (
                                                                                                            <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                <span>
                                                                                                                    <span className="badge badge-info mr-2">
                                                                                                                        POS
                                                                                                                    </span>
                                                                                                                </span>

                                                                                                                <strong>
                                                                                                                    {formatoMoneda(
                                                                                                                        p.pago.pagotarjeta.reduce(
                                                                                                                            (s, e) => s + Number(e.monto || 0),
                                                                                                                            0
                                                                                                                        )
                                                                                                                    )}
                                                                                                                </strong>

                                                                                                            </div>
                                                                                                        )}

                                                                                                        {p.pago.pagotransferencia?.length > 0 && (
                                                                                                            <div className="d-flex justify-content-between align-items-center mb-1">

                                                                                                                <span>
                                                                                                                    <span className="badge badge-primary mr-2">
                                                                                                                        Transferencia
                                                                                                                    </span>
                                                                                                                </span>

                                                                                                                <strong>
                                                                                                                    {formatoMoneda(
                                                                                                                        p.pago.pagotransferencia.reduce(
                                                                                                                            (s, e) => s + Number(e.monto || 0),
                                                                                                                            0
                                                                                                                        )
                                                                                                                    )}
                                                                                                                </strong>

                                                                                                            </div>
                                                                                                        )}

                                                                                                        {(Number(p.pago.recibido || 0) >
                                                                                                            Number(p.pago.pago || 0)) && (

                                                                                                                <>
                                                                                                                    <hr className="my-1" />

                                                                                                                    <div className="d-flex justify-content-between align-items-center">

                                                                                                                        <span className="text-danger">
                                                                                                                            <i className="fas fa-undo-alt mr-1"></i>
                                                                                                                            Cambio
                                                                                                                        </span>

                                                                                                                        <strong className="text-danger">
                                                                                                                            {formatoMoneda(
                                                                                                                                Number(p.pago.recibido || 0) -
                                                                                                                                Number(p.pago.pago || 0)
                                                                                                                            )}
                                                                                                                        </strong>

                                                                                                                    </div>
                                                                                                                </>
                                                                                                            )}

                                                                                                    </td>

                                                                                                    <td className="text-right font-weight-bold text-danger">

                                                                                                        {formatoMoneda(
                                                                                                            p.pago.pago
                                                                                                        )}

                                                                                                    </td>

                                                                                                </tr>

                                                                                            ))}

                                                                                    </tbody>

                                                                                    <tfoot>

                                                                                        <tr>

                                                                                            <td
                                                                                                colSpan="3"
                                                                                                className="text-right font-weight-bold border-top"
                                                                                            >
                                                                                                Total Anulado
                                                                                            </td>

                                                                                            <td className="text-right font-weight-bold text-danger border-top">

                                                                                                {formatoMoneda(
                                                                                                    ventaSeleccionada.pagoVenta
                                                                                                        .filter(
                                                                                                            p =>
                                                                                                                p.pago.estado ===
                                                                                                                "Anulada"
                                                                                                        )
                                                                                                        .reduce(
                                                                                                            (sum, p) =>
                                                                                                                sum +
                                                                                                                Number(
                                                                                                                    p.pago.pago ||
                                                                                                                    0
                                                                                                                ),
                                                                                                            0
                                                                                                        )
                                                                                                )}

                                                                                            </td>

                                                                                        </tr>

                                                                                    </tfoot>

                                                                                </table>

                                                                            </div>

                                                                        </div>

                                                                    </div>
                                                                )}
                                                        </>
                                                    );
                                                })()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="alert alert-info text-center py-4 shadow-sm" role="alert">
                                <h5 className="mb-0">ℹ️ No hay detalles o movimientos de pago registrados para esta venta.</h5>
                            </div>
                        )}
                    </Card>
                </div>
            )}
        </Page>
    );
};

export default HomeCredito;